export default __webpack_public_path__ + "static/media/google_play.78d9a1a1.svg";